import React from 'react'
import { connect } from 'react-redux'
import { selectConsent } from '../../../store/consent'
import Helmet from 'react-helmet'

const GA = ({ consent, gaId }) => {
  const anonymizeIP = !consent.allowed

  return (
    <Helmet>
      <script
        async
        src={`https://www.googletagmanager.com/gtag/js?id=${gaId || 'G-1CF7RNRGCZ'}`}
      />
      <script
        dangerouslySetInnerHTML={{
          __html: `
          window.dataLayer = window.dataLayer || [];
          function gtag(){dataLayer.push(arguments);}
          gtag('js', new Date());
          gtag('config', '${gaId || 'G-1CF7RNRGCZ'}', { anonymizeIP: ${anonymizeIP} });`
        }}
      />
    </Helmet>
  )
}

const mapStateToProps = state => ({
  consent: selectConsent(state)
})

export default connect(mapStateToProps)(GA)
